import React from "react";

export const Introduction = () => {
	return (
		<>
			{/* Header */}
			<h2 className={`text-2xl font-bold mb-2 text-center mt-2`}>
				Introduction
			</h2>

			{/* Page Content */}
			<div className={"pt-2 sm:px-2 sm:pt-8 text-sm"}>
				{/* <p className="mb-4 sm:mb-6">
					Your Health Companion is for your personal use, as well as to help you
					communicate with your NHS nurse, NHS Cancer Nurse Specialist (CNS) or
					with your private provider. NHS nurse services should be aware and
					familiar with Your Health Companion.
				</p> */}
				<p className={"mb-4 sm:mb-6 "}>
					To start, we need to capture a few pieces of information about you to
					create your account. You will need your NHS or CHI number. This is a
					10 digit number like 485 777 3456. You can find it on any document the
					NHS has sent you, or on any online GP service.
				</p>

				<p className={"mb-4 sm:mb-6 "}>
					Any input field marked with <b>*</b> is mandatory, all others are
					optional. Any personal identification information is used solely to
					administer your account. It is never passed to 3<sup>rd</sup> parties.
				</p>

				<p className={"mb-4 sm:mb-6 "}>
					Press Next to start the registration process. If you have any
					problems, please contact us at:
				</p>

				<p className={"sm:mb-2"}>
					<span className={"w-16 inline-block font-bold "}>Email:</span>
					<a href={`mailto:help@health-companion.me`}>
						help@health-companion.me
					</a>
				</p>
				<p className={"sm:mb-4"}>
					<span className={"w-16 inline-block font-bold "}>Tel:</span>
					<a href={`tel:01162185718`}>0116 218 5718</a>
				</p>
			</div>
		</>
	);
};
